import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { ISportsFacilities } from "src/app/interfaces/sports-facility.interface";
import { FacilityService } from "src/app/services/facility/facility.service";

type ICourtsIterator = {
  mainTitle: string;
  redirectLink: string;
  iterator: ISportsFacilities[];
};

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  isLoading: boolean = false;
  courtsAll: ISportsFacilities[] = [];
  courts: ICourtsIterator = {
    mainTitle: "Courts",
    redirectLink: "courts",
    iterator: [],
  };

  teams = {
    mainTitle: "Teams",
    redirectLink: "teams",
    iterator: [],
  };

  constructor(
    private facilityService: FacilityService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.getAllData();
  }

  getAllData = async (params: any = null) => {
    this.isLoading = true;
    try {
      this.facilityService.getAllFacilities(params).subscribe({
        next: (res) => {
          this.courts.iterator = res?.sort(
            (a: any, b: any) => Number(a.id) - Number(b.id)
          ) as ISportsFacilities[];

          this.courtsAll = this.courts.iterator;
        },
        error: (err) => {
          console.log("error while getting facilities", err);
        },
      });
    } catch (error: any) {
      console.log("error while displaying", error);
    } finally {
      this.isLoading = false;
    }
  };

  onOpenAndroid = () => {
    const playstoreURL =
      "https://play.google.com/store/apps/details?id=com.app.khelcourt";
    const isAndroid = /android/i.test(navigator.userAgent);
    if (isAndroid) {
      this.document.location.href = playstoreURL;
    } else {
      window.open(playstoreURL, "_blank");
    }
  };

  onOpenIOS = () => {
    const appStoreURL = "https://apps.apple.com/pk/app/khelcourt/id6737693015";
    const isAppleDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isAppleDevice) {
      this.document.location.href = appStoreURL;
    } else {
      window.open(appStoreURL, "_blank");
    }
  };

  onPerformSearch = (event: any) => {
    if (!event) {
      this.getAllData();
    }
    this.isLoading = true;

    const sportsCategory = event?.["sportsCategory"];
    const input = event?.["input"];

    const sportsFacilities = [];
    for (const facility of this.courtsAll) {
      let hasMatchingCategory;
      let matchedInput;
      hasMatchingCategory = facility.courts?.some((court: any) =>
        sportsCategory?.toLowerCase() === "all"
          ? true
          : court.sportsCategories?.some(
              (category: any) => category.name === sportsCategory
            )
      );

      if (input) {
        matchedInput = facility.courts.some((court) => {
          court.name.toLocaleLowerCase().includes(input?.toLocaleLowerCase()) ||
            court.address?.toLocaleLowerCase()?.includes(input?.toLocaleLowerCase());
        });
        if (
          facility.name?.toLocaleLowerCase()?.includes(input?.toLocaleLowerCase())
        )
          matchedInput = true;
      }
      if (!matchedInput && !hasMatchingCategory) continue;
      sportsFacilities.push({
        ...facility,
      });
    }
    this.courts.iterator = sportsFacilities;
    let timer = setTimeout(() => {
      clearTimeout(timer);
      this.isLoading = false;
    }, 500);
  };
}
